import * as Border from './_generated/Border';
import * as Colors from './_generated/Colors';
import * as FontFamily from './_generated/FontFamily';
import * as Icon from './_generated/Icon';
import * as Padding from './_generated/Padding';
import * as ScreenSizes from './_generated/ScreenSizes';
import * as Shadow from './_generated/Shadow';
import * as Spacing from './_generated/Spacing';
import * as Stroke from './_generated/Stroke';
import * as Typography from './_generated/Typography';
import { FontVariantToken, HeaderVariants, } from './_generated/Typography';
export default {
    Colors,
    ScreenSizes,
    FontFamily,
    Border,
    Icon,
    Padding,
    Shadow,
    Stroke,
    Spacing,
    Typography,
    FontVariantToken,
    HeaderVariants,
};
// For direct imports
export { Colors, ScreenSizes, FontFamily, Border, Icon, Padding, Shadow, Stroke, Spacing, Typography, FontVariantToken, HeaderVariants, };
export { lightPalette, lightHighContrastPalette, darkPalette, } from './jss/palette';
